import { z } from 'zod';

export const ModelType = z.enum(['RO1', 'Thor', 'Spark']);
export type ModelType = z.infer<typeof ModelType>;

export const CBVoltage = z.enum(['V24', 'V42', 'V48', 'V56']);
export type CBVoltage = z.infer<typeof CBVoltage>;
